import { useState } from "react";

import { MenuItem } from "pages/setting/components/Sections/components/MenuItem";
import { SettingSection } from "pages/setting/components/Sections/components/SettingSection";
import { AdminLeaveConfirmModal } from "pages/setting/components/Sections/NormalSetting/Modals/AdminLeaveConfirmModal";
import { ProfileSettingModal } from "pages/setting/components/Sections/NormalSetting/Modals/ProfileSettingModal";

export const NormalSetting = () => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);

  const openModal = () => {
    setIsProfileModalOpen(true);
  };

  const openPermissionModal = () => {
    setIsPermissionModalOpen(true);
  };

  const closePermissionModal = () => {
    setIsPermissionModalOpen(false);
  };

  return (
    <SettingSection sectionName="기본 설정">
      <ul style={{ listStyle: "none", flexGrow: 2, margin: 0, padding: 0 }}>
        {/* 첫 번째 메뉴 : 프로필 설정 */}
        <li>
          {/* 메뉴 이름 */}
          <MenuItem
            onClick={openModal}
            menuName="프로필 설정"
            style={{
              paddingBottom: "20px",
              borderBottom: "1px solid #e8e8e8",
              cursor: "pointer",
            }}
          />

          {/* 모달 */}
          <ProfileSettingModal
            isModalOpen={isProfileModalOpen}
            setIsModalOpen={setIsProfileModalOpen}
          />
        </li>

        {/* 2번째 메뉴 : 관리자 권한 탈퇴하기 */}
        <li>
          {/* 메뉴 이름 */}
          <MenuItem
            onClick={openPermissionModal}
            menuName="관리자 권한 탈퇴하기"
            style={{ paddingTop: "20px", cursor: "pointer" }}
          />

          {/* 모달 */}
          <AdminLeaveConfirmModal
            isMoalOpen={isPermissionModalOpen}
            closeModal={closePermissionModal}
          />
        </li>
      </ul>
    </SettingSection>
  );
};
